import { render, staticRenderFns } from "./ManageVideoType.vue?vue&type=template&id=c6ff0146&scoped=true&"
import script from "./ManageVideoType.vue?vue&type=script&lang=js&"
export * from "./ManageVideoType.vue?vue&type=script&lang=js&"
import style0 from "./style.scss?vue&type=style&index=0&id=c6ff0146&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c6ff0146",
  null
  
)

export default component.exports